<script>
  export default {
    name: 'OperationButtons',
    props: {
      // 是否显示上一步按钮
      showPrev: {
        type: Boolean,
        default: true
      },
      // 是否显示下一步按钮
      showNext: {
        type: Boolean,
        default: true
      },
      // 是否显示取消按钮
      showCancel: {
        type: Boolean,
        default: true
      },
      // 是否显示保存草稿按钮
      showSaveDraft: {
        type: Boolean,
        default: true
      },
      // 是否显示提交审核按钮
      showSubmit: {
        type: Boolean,
        default: true
      },
      // 当前步骤索引
      currentIndex: {
        type: Number,
        default: 0
      },
      // 总步骤数
      totalSteps: {
        type: Number,
        default: 1
      }
    },
    computed: {
      // 是否为第一步
      isFirstStep() {
        return this.currentIndex === 0
      },
      // 是否为最后一步
      isLastStep() {
        return this.currentIndex === this.totalSteps - 1
      }
    },
    methods: {
      handleCancel() {
        this.$emit('cancel')
      },
      handleSaveDraft() {
        this.$emit('save-draft')
      },
      handlePrev() {
        if (!this.isFirstStep) {
          this.$emit('prev')
        }
      },
      handleNext() {
        if (!this.isLastStep) {
          this.$emit('next')
        }
      },
      handleSubmit() {
        this.$emit('submit')
      }
    }
  }
</script>

<template>
  <div class="operation-buttons">
    <el-button @click="handleCancel" v-if="showCancel">取消</el-button>
    <el-button @click="handleSaveDraft" v-if="showSaveDraft">保存草稿</el-button>
    <el-button type="primary" @click="handlePrev" v-if="showPrev && !isFirstStep">上一步</el-button>
    <el-button type="primary" @click="handleNext" v-if="showNext && !isLastStep">下一步</el-button>
    <el-button type="primary" @click="handleSubmit" v-if="showSubmit">提交审核</el-button>
  </div>
</template>

<style scoped lang="scss">
  .operation-buttons {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-top: 20px;
  }
</style>
